import { useEffect, useRef, useState } from 'react'
import { Image } from 'react-native'
import { useNavigate } from 'react-router-dom'
import { AnimatePresence, motion } from 'framer-motion'
import useDimension from '../../hooks/use-dimension'
import PageBg from '../../components/PageBg'
import Story from '../../components/elements/Story'
import { roleStories } from '../../data/contents'
import { imgIntro, imgCommons } from '../../data/images'
import { useGameContext } from '../../context/GameContext'
import { useAudio } from '../../context/AudioContext'

const { bgRole, btnStart, btnNext } = imgIntro
const { roles } = imgCommons

const roleStyle = {
  a: {
    0: { width: 242.8, height: 539.5, top: 100.5, left: 31.7 },
    1: { width: 290, height: 539.5, top: 101.5, left: 59.7 },
  },
  b: {
    0: { width: 284.1, height: 535.9, top: 104.1, left: 38.4 },
    1: { width: 284.1, height: 548, top: 92, left: 42.3 },
  },
  c: {
    0: { width: 204.1, height: 544.2, top: 95.8, left: 78.1 },
    1: { width: 260.8, height: 544.2, top: 95.8, left: 49.8 },
  },
  d: {
    0: { width: 226.1, height: 555, top: 85, left: 67.1 },
    1: { width: 279.7, height: 555, top: 85, left: 40.3 },
  },
  e: {
    0: { width: 255, height: 555, top: 85, left: 52.6 },
    1: { width: 313.2, height: 555, top: 85, left: 23.5 },
  },
}
type RoleKey = 'a' | 'b' | 'c' | 'd' | 'e'
const IntroRole = () => {
  const { ws } = useDimension()
  const { role } = useGameContext() as { role: RoleKey }
  const { updateSelectRole } = useGameContext()

  const navigate = useNavigate()
  const { isPlaying, setVolumeValue } = useAudio()

  const sound1Ref = useRef<HTMLAudioElement | null>(null)
  const sound2Ref = useRef<HTMLAudioElement | null>(null)
  const [soundInit, setSoundInit] = useState(false)

  const pLast = 1
  const [page, setPage] = useState<number>(0)

  const onNext = () => {
    setPage(p => p + 1)
  }

  useEffect(() => {
    if (!soundInit && role) {
      sound1Ref.current = new Audio(`/audio/${role}-1.mp3`)
      sound2Ref.current = new Audio(`/audio/${role}-2.mp3`)
      setSoundInit(true)
    }
  }, [role, soundInit])

  useEffect(() => {
    const sound1 = sound1Ref.current
    const sound2 = sound2Ref.current
    const playSound = async () => {
      try {
        setVolumeValue(0.2)

        if (sound1 && !sound1.paused) {
          sound1.pause()
          sound1.currentTime = 0
        }
        if (sound2 && !sound2.paused) {
          sound2.pause()
          sound2.currentTime = 0
        }

        // 根據頁面播放對應音效
        if (isPlaying) {
          if (page === 0 && sound1) {
            try {
              await sound1.play()
            } catch (error) {
              console.warn('Sound1 play failed:', error)
            }
          }

          if (page === pLast && sound2) {
            try {
              await sound2.play()
            } catch (error) {
              console.warn('Sound2 play failed:', error)
            }
          }
        }
      } catch (error) {
        console.error('Sound play error:', error)
      }
    }

    playSound()

    return () => {
      if (!sound1?.paused) {
        sound1?.pause()
        sound1 && (sound1.currentTime = 0)
      }
      if (!sound2?.paused) {
        sound2?.pause()
        sound2 && (sound2.currentTime = 0)
      }
    }
  }, [page, isPlaying])

  const onStart = () => {
    updateSelectRole(true)
    setVolumeValue(1)
    navigate('/main', { replace: true })
  }

  if (!role || !roleStyle[role]) {
    return <div>Loading...</div>
  }
  return (
    <AnimatePresence>
      <motion.div
        key={page}
        initial={{ opacity: 0.65 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 1 }}
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
        }}
      >
        <PageBg src={bgRole} alt={`bg-intro`}>
          {true && (
            <motion.div
              key={`role-${page}`}
              style={{
                width: roleStyle[role][page as 0 | 1].width * ws,
                height: roleStyle[role][page as 0 | 1].height * ws,
                position: 'absolute',
                top: roleStyle[role][page as 0 | 1].top * ws,
                left: roleStyle[role][page as 0 | 1].left * ws,
              }}
              initial={{ x: page === 0 ? -200 : 0, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.7 }}
            >
              <Image
                source={{
                  uri:
                    page === 0
                      ? roles[role].role1
                      : roles[role].role2,
                }}
                style={{
                  width: '100%',
                  height: '100%',
                }}
                resizeMode="contain"
                aria-label={`content`}
              />
            </motion.div>
          )}
          <motion.div
            className="motion-wrapper txt-story"
            key={page}
            style={{ margin: '10%' }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ delay: 0.7, duration: 0.5 }}
          >
            <Story
              btn={{
                btnSrc: page === pLast ? btnStart : btnNext,
                onPress: page === pLast ? onStart : onNext,
                pLast: page === pLast ? true : false,
              }}
              txts={roleStories.introRole[role][page]}
              side="down"
            />
          </motion.div>
        </PageBg>
      </motion.div>
    </AnimatePresence>
  )
}

export default IntroRole
